import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (localStorage.getItem('user_token')) {
            return true;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_guards/auth.guard.ts